var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"image-viewer"},[_c('div',{staticClass:"image-container"},[_c('img',{style:({ width: _vm.imgWidth + 'px', height: _vm.imgHeight + 'px' }),attrs:{"src":_vm.imageUrl}}),_c('i',{staticClass:"el-icon-close close-icon",on:{"click":_vm.close}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }